import { render, staticRenderFns } from "./_form.timeline-lists.page.vue?vue&type=template&id=10569ff0&scoped=true&"
import script from "./_form.timeline-lists.page.vue?vue&type=script&lang=js&"
export * from "./_form.timeline-lists.page.vue?vue&type=script&lang=js&"
import style0 from "./_form.timeline-lists.page.vue?vue&type=style&index=0&id=10569ff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10569ff0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VForm,VIcon})
